/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-add-user-access p-multiselectitem li.ui-state-disabled.ui-multiselect-item>div.ui-chkbox{display:none!important}app-add-user-access p-multiselectitem li.ui-state-disabled.ui-multiselect-item>label{font-weight:700!important;font-size:12px}app-add-user-access .pi-info-circle{font-size:25px!important}app-add-user-access .check-circle-gray,app-add-user-access .info-circle-gray{font-size:20px;color:gray}app-add-user-access .check-circle-green{font-size:20px;color:#0c0!important}app-add-user-access .no-flicker{pointer-events:none!important}"];
export { styles as styles };
